<div class="form-group row mb-1" #formGroupRef>
    <label *ngIf="label" [attr.for]="label | monRemoveWhiteSpace" class="col-sm-8 col-form-label text-bold capitalize-first-letter text-right">
        {{ label }}<span *ngIf="ngRequired || required">*</span>
    </label>
    <div [ngClass]="{'col-sm-40' : label, 'col-sm-48': !label }">
        <textarea
            [(ngModel)]="value"
            [name]="'textarea-' + (label | monRemoveWhiteSpace)"
            [attr.data-test]="'text-area-' + (label | e2eAttributeEncoding)"
            [class]="'form-control ' + (isFieldValid() ? '' : 'is-invalid')"
            [attr.id]="label | monRemoveWhiteSpace"
            [attr.placeholder]="placeholder"
            [disabled]="disabled"
            [attr.rows]="rows"
            (blur)="onTextareaBlur()"
            (input)="onTextareaChange($event)"
            (keyup)="onTextareaKeyup($event)">
        </textarea>
        <span class="form-text text-muted">{{ helpTxt }}</span>
    </div>
</div>
